import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    id: "address-modal",
    class: "modal type1 js-modal"
};
const _hoisted_2 = { class: "modal-content" };
const _hoisted_3 = { class: "pop" };
const _hoisted_4 = ["value"];
const _hoisted_5 = { class: "bt_box clear" };
const _hoisted_6 = {
    key: 0,
    class: "err_list"
};
import { reactive, ref, watch, onMounted } from 'vue';
import ImageFrame from '@component/ImageFrame.vue';
import SearchPostalCode from '@util/SearchPostalCode';
import Alert from '@util/BrowserAlert';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AddressModal',
    props: {
        options: { default: [] },
        form: {},
        errors: {}
    },
    emits: ['input', 'cancel'],
    setup(__props, { expose: __expose, emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const close = ref();
        const form = reactive({
            postal_code: '',
            prefecture_id: null,
            city: '',
            building: '',
        });
        watch(() => form.postal_code, (value) => {
            const pattern = /[^0-9-]/g;
            form.postal_code = value.replace(pattern, '');
        });
        // 文字数チェック
        watch(() => form.city, (value) => {
            if (Alert.charLimitText(value)) {
                form.city = value.substring(0, Alert.TEXT_LIMIT_NUMBER);
            }
        });
        watch(() => form.building, (value) => {
            if (Alert.charLimitText(value)) {
                form.building = value.substring(0, Alert.TEXT_LIMIT_NUMBER);
            }
        });
        const searchPostalCode = () => {
            SearchPostalCode(form.postal_code, (value) => {
                var _a, _b, _c, _d;
                form.prefecture_id = (_a = value === null || value === void 0 ? void 0 : value.region_id) !== null && _a !== void 0 ? _a : '';
                form.city = `${(_b = value === null || value === void 0 ? void 0 : value.locality) !== null && _b !== void 0 ? _b : ''}${(_c = value === null || value === void 0 ? void 0 : value.street) !== null && _c !== void 0 ? _c : ''}`;
                form.building = (_d = value === null || value === void 0 ? void 0 : value.extended) !== null && _d !== void 0 ? _d : '';
            });
        };
        // キャンセルボタン
        const onClickCancel = () => {
            var _a, _b, _c, _d;
            form.postal_code = (_a = props.form.postal_code) !== null && _a !== void 0 ? _a : '';
            form.prefecture_id = (_b = props.form.prefecture_id) !== null && _b !== void 0 ? _b : null;
            form.city = (_c = props.form.city) !== null && _c !== void 0 ? _c : '';
            form.building = (_d = props.form.building) !== null && _d !== void 0 ? _d : '';
            emit('cancel');
        };
        // OKボタン
        const onClickOk = () => {
            emit('input', Object.assign({}, form));
        };
        const onCloseModal = () => {
            close.value.click();
        };
        onMounted(() => {
            var _a, _b, _c, _d;
            form.postal_code = (_a = props.form.postal_code) !== null && _a !== void 0 ? _a : '';
            form.prefecture_id = (_b = props.form.prefecture_id) !== null && _b !== void 0 ? _b : null;
            form.city = (_c = props.form.city) !== null && _c !== void 0 ? _c : '';
            form.building = (_d = props.form.building) !== null && _d !== void 0 ? _d : '';
        });
        __expose({
            onCloseModal,
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", {
                    class: "modal-bg bt_modal_close",
                    onClick: onClickCancel
                }),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", {
                        class: "close_bt bt_modal_close",
                        onClick: onClickCancel
                    }, [
                        _createVNode(ImageFrame, { src: "images/common/i_bt_close.svg" })
                    ]),
                    _createElementVNode("div", _hoisted_3, [
                        _cache[5] || (_cache[5] = _createElementVNode("h2", null, "連絡先住所", -1)),
                        _cache[6] || (_cache[6] = _createElementVNode("p", { class: "sub_t nobr" }, "〒", -1)),
                        _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((form.postal_code) = $event)),
                            minlength: "7",
                            maxlength: "8",
                            type: "text",
                            name: "zip",
                            onKeyUp: "AjaxZip3.zip2addr(this,'','address1','address2');",
                            class: "w30",
                            onInput: searchPostalCode
                        }, null, 544), [
                            [_vModelText, form.postal_code]
                        ]),
                        _cache[7] || (_cache[7] = _createElementVNode("p", { class: "sub_t" }, "都道府県", -1)),
                        _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((form.prefecture_id) = $event)),
                            name: "address1",
                            class: "w30"
                        }, [
                            _cache[4] || (_cache[4] = _createElementVNode("option", { value: "" }, "　　　　", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.options, (option) => {
                                return (_openBlock(), _createElementBlock("option", {
                                    value: option.id
                                }, _toDisplayString(option.name), 9, _hoisted_4));
                            }), 256))
                        ], 512), [
                            [_vModelSelect, form.prefecture_id]
                        ]),
                        _cache[8] || (_cache[8] = _createElementVNode("p", { class: "sub_t" }, "市区町村・番地", -1)),
                        _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((form.city) = $event)),
                            type: "text",
                            name: "address2",
                            class: "wmax"
                        }, null, 512), [
                            [_vModelText, form.city]
                        ]),
                        _cache[9] || (_cache[9] = _createElementVNode("p", { class: "sub_t" }, "建物名等", -1)),
                        _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((form.building) = $event)),
                            type: "text",
                            class: "wmax",
                            placeholder: "例：山田ビル 101"
                        }, null, 512), [
                            [_vModelText, form.building]
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                            (props === null || props === void 0 ? void 0 : props.errors)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.errors, (error) => {
                                        return (_openBlock(), _createElementBlock("p", null, _toDisplayString(error), 1));
                                    }), 256))
                                ]))
                                : _createCommentVNode("", true),
                            _createElementVNode("ul", { class: "modalBtn-area b2" }, [
                                _createElementVNode("li", null, [
                                    _createElementVNode("p", {
                                        class: "bt_modal_close bt_clear",
                                        onClick: onClickCancel
                                    }, "キャンセル")
                                ]),
                                _createElementVNode("li", null, [
                                    _createElementVNode("p", {
                                        class: "bt_ok",
                                        onClick: onClickOk
                                    }, "OK")
                                ])
                            ]),
                            _createElementVNode("p", {
                                class: "bt_modal_close",
                                ref_key: "close",
                                ref: close,
                                style: { "display": "none" }
                            }, null, 512)
                        ])
                    ])
                ])
            ]));
        };
    }
});
